import * as uuid from "uuid";
import {
    addErrorAlert,
    addProduct,
    cancelAllPendingRfidTags,
    changeTransactionMode,
    closeDialogue,
    closeModal,
    findCustomerByCardNumber,
    findProduct,
    getPOSLog,
    getPOSLogBySpecialOrderNumber,
    getTransactionLinkPOSLog,
    getUserRights,
    openGetUserRightsByPinModal,
    openModal,
    productNotFound,
    setBlockScannersNormalAction,
    setCustomer,
    setLoading,
    setTransactionUser,
    showDialogue
} from "../../actions";
import {getTranslate} from "../../../localization/localizeSlice";
import Customer from "../../dto/customer";
import {
    PRODUCT_RFID_TAG_DETECTED,
    RETURN_RECEIPT_SUBMITTED,
    SCANNER_DETECTED,
    SET_RETURN_BASE_POSLOG,
    START_RFID_READER,
    STOP_RFID_READER
} from "../../actionTypes";
import React from "react";
import ReturnPOSLog from "../../../main/administration/ReturnPOSLog";
import RFIDService from "../../rfid/RFIDService";
import {
    getHasRightToMakeDiscount,
    getNumberOfPendingRFIDProducts,
    getUnknownItemCode,
    mixedTransactions
} from "../../selectors";
import {createBarcode} from "../../../util/helperFunctions";
import {DECATHLON_RFID_SERIAL_DEFAULT} from "../../appConstants";
import Translate from "../../../localization/Translate";
import Button from "../../../buttons/Button";
import {calculateUsedProductNetPrice, negateProductAmount, PDTB} from "../../../util/product";
import {useDispatch, useSelector} from "react-redux";
import {useActionListener} from "redux-action-listener-hook";
import ProductSearch from "../../../main/ProductSearch";
import {findUnknownProduct} from "../../../main/administration/UnknownItem";

const getReferencePOSLog = (referenceReceiptNumber, webOrderNumber, store) => {
    let findPOSLog = () => {
        return new Promise((resolve, reject) => {
            if(referenceReceiptNumber !== ''){
                store.dispatch(getPOSLog(referenceReceiptNumber, resolve, reject));
            }else{
                store.dispatch(getPOSLogBySpecialOrderNumber(webOrderNumber, resolve, reject));
            }
        });
    }
    return new Promise((resolve, reject) => {
        findPOSLog().then((response) => {
            console.log("findPOSLog", response);
            let result = JSON.parse(response);
            if(result.status.responseStatus === 'ok'){
                if(result.data.metadata.hits > 0){
                    let poslog = result.data.data[0].poslog;
                    store.dispatch(getTransactionLinkPOSLog(poslog.transaction.transactionID, (linkResponse) => {
                        let linkedPoslogs = [];
                        let linkResult = JSON.parse(linkResponse);
                        if(linkResult.status.responseStatus === 'ok') {
                            if (linkResult.data.metadata.hits > 0) {
                                linkedPoslogs = linkResult.data.data;
                            }
                        }
                        resolve({poslog, linkedPoslogs});
                    }, () => {
                        resolve({poslog});
                    }));
                }else{
                    reject(false);
                }
            }else{
                reject(true);
            }
        }, (error) => {
            console.log("validate reference receipt number error", error);
            reject(true);
        });
    });
};
export const onReturnMode = (store, state) => {
    let dispatch = store.dispatch;

    if(state.rootReducer.returnBasePOSLog !== false){
        dispatch(addErrorAlert("Return already in progress"));
        dispatch(changeTransactionMode('SALE'));
        return;
    }

    const tryAskReferenceReceiptNumber = (referenceReceiptNumber = '', webOrderNumber = '') => {
        const doFinally = () => {
            dispatch({type: START_RFID_READER});
        }
        askReferenceReceiptNumber(store, referenceReceiptNumber, webOrderNumber).then(({referenceReceiptNumber, webOrderNumber}) => {
            dispatch(setLoading(true));
            dispatch({
                type: RETURN_RECEIPT_SUBMITTED,
                payload: {
                    referenceReceiptNumber,
                    webOrderNumber
                }
            });

            getReferencePOSLog(referenceReceiptNumber, webOrderNumber, store).then(({poslog, linkedPoslogs}) => {
                dispatch(setLoading(false));
                doFinally();
                let refundModal = uuid.v4();
                dispatch(setBlockScannersNormalAction(true));
                let tags = [];
                dispatch(openModal({
                    content:
                        <ReturnPOSLog
                            poslog={poslog}
                            linkedPoslogs={linkedPoslogs}
                            onDone={(selectedProducts) => {
                                console.log({selectedProducts});
                                if(selectedProducts.length === 0){
                                    dispatch(addErrorAlert('Please select at least one item'))
                                }else{
                                    dispatch(setBlockScannersNormalAction(false));
                                    dispatch(closeModal(refundModal));
                                    selectedProducts.forEach((product) => {
                                        if(typeof product.erplyProduct !== "undefined"){
                                            product.erplyProduct.setVatPrice(product.price);
                                            product.erplyProduct.amount = product.returnAmount ?? product.amount;

                                            if(product.erplyProduct.data.isUsedProduct === 1){
                                                product.erplyProduct.setNetPrice(calculateUsedProductNetPrice(product.price, product.erplyProduct.data.vatrate, product.erplyProduct.data.cost));
                                            }

                                            product.erplyProduct.baseDocumentRow = {
                                                amount: product.amount,
                                                itemName: product.itemName,
                                                price: product.price
                                            };
                                            product.erplyProduct.manualPrice = true;
                                            product.erplyProduct.setNotDiscountable();
                                            dispatch(addProduct(product.erplyProduct));
                                        }
                                    });
                                    dispatch(setLoading(true));
                                    addReturnProducts(selectedProducts.reduce((acc, el) => {
                                        if(typeof el.erplyProduct === "undefined"){
                                            acc.push(el);
                                        }
                                        return acc;
                                    },[]), dispatch, state.rootReducer.pos.warehouseID, state.rootReducer.pos.pointOfSaleID).then(() => {
                                        dispatch({
                                            type: SET_RETURN_BASE_POSLOG,
                                            payload: {
                                                ...poslog,
                                                linkedPoslogs
                                            }
                                        });
                                        dispatch(setLoading(false));
                                        if(mixedTransactions()){
                                            dispatch(changeTransactionMode('SALE'));
                                        }
                                    });
                                }
                            }}
                            onRFIDTagAdded={(tag) => {
                                tags.push(tag);
                            }}
                            onManualSelect={(checked) => {
                                console.log("onManualSelect", {checked})
                                return new Promise((resolve, reject) => {
                                    if(window.AppConf.verifiedReturn.manualSupervisor && checked){
                                        validateSupervisor('Supervisor validation needed for manual selection!', dispatch, state, resolve, reject, reject);
                                    }else{
                                        resolve();
                                    }
                                });
                            }}
                        />,
                    id: refundModal,
                    className: "Administration",
                    onClose: () => {
                        dispatch(setBlockScannersNormalAction(false));
                        dispatch(changeTransactionMode('SALE'));
                        dispatch(setCustomer(false));
                        tags.forEach((tag) => {
                            RFIDService.cancelRFIDLine(tag, ()=>{});
                        });
                    },
                    canClose: true
                }));

                let customerAccountNumber = poslog.transaction.retailTransaction?.customer?.[0]?.customerID;
                if(typeof customerAccountNumber !== "undefined"){
                    dispatch(setLoading(true));
                    dispatch(findCustomerByCardNumber(customerAccountNumber, (customer) => {
                        customer.canRemove = false;
                        dispatch(setLoading(false));
                    }, () => {
                        dispatch(setLoading(false));
                        let customer = new Customer(customerAccountNumber);
                        customer.canRemove = false;
                        dispatch(setCustomer(customer));
                    }));
                }
            }, () => {
                dispatch(setLoading(false));
                dispatch(addErrorAlert('The specified proof of purchase could not be found. Please check your input.'));
                tryAskReferenceReceiptNumber(referenceReceiptNumber, webOrderNumber);
            });
        }, () => {
            doFinally();
        });
    }

    stopRFIDReading(store, dispatch);
    tryAskReferenceReceiptNumber();
}

const stopRFIDReading = (store, dispatch, retry=0) => {
    let state = store.getState();
    if(state.rootReducer.rfidStatus === 'reading'){
        dispatch({type: STOP_RFID_READER});
    }else{
        if(retry < 20){
            setTimeout(() => {
                stopRFIDReading(store, dispatch, retry + 1);
            }, 250);
        }
    }
}

const getTransactionUserID = (state) => {
    return (state.rootReducer.transactionUser !== false ? state.rootReducer.transactionUser.userID : state.rootReducer.user.userID);
}
const validateSupervisor = (title, dispatch, state, onSuccess, onFail, onClose, checkTransactionUser=false) => {
    dispatch(openGetUserRightsByPinModal(dispatch, state.rootReducer.user.clientCode, state.rootReducer.posID, ((userRights, supervisor) => {
        // if offline user
        if(supervisor.id === 0){
            onSuccess();
            return;
        }
        if((checkTransactionUser ? getTransactionUserID(state) : state.rootReducer.user.userID) === supervisor.userID) {
            dispatch(addErrorAlert('Users cannot self-validate!'));
            onFail();
            return;
        }
        if(getHasRightToMakeDiscount(userRights)){
            dispatch(setTransactionUser(supervisor));
            onSuccess();
        }else{
            dispatch(addErrorAlert('User has no right to perform this action!'));
            onFail();
        }
    }), onClose, true, title));
}
const transactionUserIsSupervisor = (dispatch, state) => {
    return new Promise((resolve, reject) => {
        const user = state.rootReducer.transactionUser !== false ? state.rootReducer.transactionUser : state.rootReducer.user;

        dispatch(getUserRights(user.userID, state.rootReducer.posID, (records) => {
            const userRights = records[0];
            resolve(getHasRightToMakeDiscount(userRights))
            return {
                type: 'USER_RIGHTS_SUCCESS'
            }
        }, () => {
            resolve(false);
            return {
                type: 'GET_USER_RIGHTS_FAILED'
            }
        }));
    });
}
const UnverifiedReturnButton = ({dialogueID}) => {
    const dispatch = useDispatch();
    const state = useSelector(state => state);

    if(window.AppConf.verifiedReturn.override){
        return <Button
            type="button"
            className={"mediumEqualButton grayButton roundButton"}
            name={<Translate id="Unverified Return"/>}
            onClick={() => {
                if(window.AppConf.verifiedReturn.unverifiedSupervisor){
                    if(window.AppConf.verifiedReturn.unverifiedSupervisorSelfValidate){
                        transactionUserIsSupervisor(dispatch, state).then((transactionUserIsSupervisor) => {
                            if(transactionUserIsSupervisor){
                                dispatch(closeDialogue(dialogueID));
                                unverifiedReturn(dispatch);
                            }else{
                                validateSupervisor('Supervisor validation needed for unverified return!', dispatch, state, () => {
                                    dispatch(closeDialogue(dialogueID));
                                    unverifiedReturn(dispatch);
                                }, () => {}, () => {});
                            }
                        });
                    }else{
                        validateSupervisor('Supervisor validation needed for unverified return!', dispatch, state, () => {
                            dispatch(closeDialogue(dialogueID));
                            unverifiedReturn(dispatch);
                        }, () => {}, () => {}, true);
                    }
                }else{
                    dispatch(closeDialogue(dialogueID));
                    unverifiedReturn(dispatch);
                }
            }}
        />
    }

    return '';
}

let tagDetectCount = 0;
function UnverifiedReturnView({}){
    let state = useSelector(state => state);
    useActionListener(SCANNER_DETECTED, (dispatch, action) => {
        console.log({useActionListener: action});
        handleUnverifiedReturnProductScan(action.payload, dispatch, state, false);
    });
    useActionListener(PRODUCT_RFID_TAG_DETECTED, (dispatch, action) => {
        console.log({useActionListener: action});
        tagDetectCount++;
        let currentTagDetectNo = tagDetectCount;
        dispatch({type: STOP_RFID_READER});
        setTimeout(() => {
            console.log({currentTagDetectNo, tagDetectCount});
            if(currentTagDetectNo === tagDetectCount){
                handleUnverifiedReturnProductScan(action.payload.RFIDTag.GTIN, dispatch, state, action.payload.RFIDTag);
            }
        }, 1000);
    });

    return <div>
        <div style={{textAlign: "center"}}>
            <p><Translate id={"Please Drop the product on the RFID box now or scan the RFID tag."}/></p>
        </div>
    </div>;
}

const unverifiedReturn = (dispatch) => {
    dispatch({type: START_RFID_READER});
    dispatch(setBlockScannersNormalAction(true));
    dispatch(changeTransactionMode("SALE"));
    tagDetectCount = 0;
    dispatch(showDialogue(
        "Add a product",
        <UnverifiedReturnView/>,
        "Manual search", () => {
            dispatch(setBlockScannersNormalAction(false));
            dispatch({type: STOP_RFID_READER});

            dispatch(openModal({
                content: <ProductSearch
                    onSelect={product => {
                        dispatch(closeModal("productSearchModal"));
                        dispatch({type: START_RFID_READER});
                    }}
                    onClose={e => {
                        dispatch({type: START_RFID_READER});
                    }}
                    productAmount={-1}
                    productListStyle={{
                        position: 'absolute',
                        top: '90px',
                        bottom: '186px',
                        left: 0,
                        right: 0,
                        height: 'auto'
                    }}
                    notFoundContent={(query) => <div style={{margin: 20}}>
                        <Translate id={'No products match the query'}/>
                        <br/>
                        <br/>
                        <Button
                            onClick={() => {
                                dispatch(productNotFound(query, 'not found', negateProductAmount));
                                dispatch(closeModal("productSearchModal"));
                                dispatch({type: START_RFID_READER});
                            }}
                            type="button"
                            className={"mediumEqualButton blueButton roundButton uppercaseText"}
                            name={<Translate id="Add unknown item"/>}
                        />
                    </div>}
                />,
                id: "productSearchModal",
                className: "Administration",
                onClose: () => {},
                canClose: true
            }))
        },
        () => {
            dispatch(setBlockScannersNormalAction(false));
        },"Cancel", false, "unverifiedReturn", undefined, true));
};

const handleUnverifiedReturnProductScan = (scannedCode, dispatch, state, RFIDTag=false) => {
    console.log("HRV: handleSmartProductReturnScan", {scannedCode, RFIDTag});
    if(RFIDTag !== false && getNumberOfPendingRFIDProducts() > 1){
        dispatch(showDialogue(
            "Multiple products scanned",
            "Please remove all the added products from the basket and scan only one item!",
            "Ok",
            () => {
                dispatch(cancelAllPendingRfidTags(() => {
                    dispatch({type: START_RFID_READER});
                }));
            }, undefined, undefined, false, undefined, undefined, true)
        );
        return;
    }

    let searchCode = PDTB.tryAllpatterns(scannedCode);
    let barcode = scannedCode;
    if(RFIDTag !== false){
        barcode = createBarcode(RFIDTag.GTIN, RFIDTag.SERIAL_NUMBER);
    }
    dispatch(findProduct(searchCode, state.rootReducer.warehouse.warehouseID, state.rootReducer.pos.pointOfSaleID, false, (product) => {
        product.amount *= -1;
        product.calculateTotals();
        return addProduct(product);
    }, (code, error) => {
        return productNotFound(code, error, negateProductAmount, undefined, RFIDTag);
    }, undefined, undefined, undefined, false, barcode));
    dispatch(closeDialogue("unverifiedReturn"));
    setTimeout(() => {
        dispatch(setBlockScannersNormalAction(false));
        dispatch({type: START_RFID_READER});
    },1);
}

const askReferenceReceiptNumber = (store, referenceReceiptNumber = '', webOrderNumber = '') => {
    const dispatch = store.dispatch;
    const state = store.getState();
    const translate = getTranslate(state);
    const dialogueID = uuid.v4();
    let inputFields = [
        { id: 'referenceInput', name: 'Reference receipt number', type: 'input'}
    ];
    if(window.AppConf.verifiedReturn?.webOrder){
        inputFields.push({ id: 'specialOrderInput', name: 'Web order number', type: 'input'})
    }

    return new Promise((resolve, reject) => {
        dispatch({
            type: 'SHOW_DIALOGUE',
            payload: {
                id: dialogueID,
                title: translate('Verified return'),
                header: <UnverifiedReturnButton dialogueID={dialogueID}/>,
                inputFields,
                onDone: (inputValues) => {
                    if(inputValues['referenceInput'] !== ""){
                        resolve({referenceReceiptNumber: inputValues['referenceInput'], webOrderNumber: ''});
                        return;
                    }else if(inputValues['specialOrderInput'] !== ""){
                        resolve({referenceReceiptNumber: '', webOrderNumber: inputValues['specialOrderInput']});
                        return;
                    }
                    dispatch(addErrorAlert('Please enter number'));
                    askReferenceReceiptNumber(store, referenceReceiptNumber, webOrderNumber).then(resolve, reject);
                },
                onClose: () => {
                    dispatch(changeTransactionMode("SALE"));
                    reject();
                },
                canClose: true,
                multipleInputDialogue: true,
                initialValues: {
                    referenceInput: referenceReceiptNumber
                },
                initialKeyboardLayout: 'numbers',
                onScannerDetect: (code) => {
                    if(inputFields.length === 1){
                        dispatch(closeDialogue(dialogueID));
                        resolve({referenceReceiptNumber: code, webOrderNumber: ''});
                    }
                }
            }
        });
    })};

export const getTenderLines = (poslog) => {
    return poslog.transaction.retailTransaction.lineItem.filter(el => typeof el.tender !== "undefined");
}

const addReturnProducts = (selectedRows, dispatch, warehouseID, pointOfSaleID) => {
    return new Promise((resolve, reject) => {
        if(selectedRows.length === 0){
            resolve();
            return;
        }
        let productCodes = selectedRows.reduce((acc, row) => {
            acc.push(row.code);
            return acc;
        }, []);
        console.log("Manual products", {selectedRows, productCodes});
        let loadedProducts = 0;
        let allLoaded = () => {
            return loadedProducts === selectedRows.length;
        }
        selectedRows.forEach((row) => {
            let searchCode = row.poslog.sale.itemID;
            let barcode;
            let GTIN = row.poslog.sale.serialNumber.find((el) => el.type === 'GTIN');
            let RFID = row.poslog.sale.serialNumber.find((el) => el.type === 'RFID');
            if(typeof RFID !== "undefined" && RFID.value === DECATHLON_RFID_SERIAL_DEFAULT){
                let itemID = row.poslog.sale.serialNumber.find((el) => el.type === 'ItemID');
                if(typeof itemID !== "undefined"){
                    RFID = itemID;
                }
            }
            if(typeof GTIN !== "undefined" && typeof RFID !== "undefined"){
                if(RFID.value !== DECATHLON_RFID_SERIAL_DEFAULT){
                    barcode = createBarcode(GTIN.value, RFID.value);
                }
            }
            let inputString = row.poslog.sale.serialNumber.find((el) => el.type === 'DKT:InputString');
            if(typeof inputString !== "undefined"){
                inputString = inputString.value;
            }

            dispatch(findProduct(searchCode, warehouseID, pointOfSaleID, false, (product) => {
                console.log("Return POSLog product found", {product});
                loadedProducts++;
                if(typeof RFID !== "undefined"){
                    if(RFID.value !== DECATHLON_RFID_SERIAL_DEFAULT){
                        product.data.RFIDSerialNumber = RFID.value;
                    }
                }
                product.inputString = inputString;
                product.setVatPrice(row.price);
                product.amount = row.returnAmount ?? row.amount;

                if(product.data.isUsedProduct === 1){
                    product.setNetPrice(calculateUsedProductNetPrice(row.price, product.data.vatrate, product.data.cost));
                }

                product.baseDocumentRow = {
                    amount: row.amount,
                    itemName: row.itemName
                };
                product.manualPrice = true;
                product.setNotDiscountable();
                setTimeout(() => {
                    if(allLoaded()){
                        resolve();
                    }
                }, 1);
                product.entryMethod = 'Automatic';
                return addProduct(product);
            }, () => {
                let isUnknownItem = row.poslog.sale?.merchandiseHierarchy?.[0]?.value === "0";
                if(isUnknownItem){
                    findUnknownProduct(dispatch, getUnknownItemCode(), warehouseID, pointOfSaleID, row.price, false, row.poslog.sale.itemID, row.poslog.sale.itemID, false, (product) => {
                        loadedProducts++;
                        setTimeout(() => {
                            if(allLoaded()){
                                resolve();
                            }
                        }, 1);
                        if(typeof RFID !== "undefined"){
                            if(RFID.value !== DECATHLON_RFID_SERIAL_DEFAULT){
                                product.data.RFIDSerialNumber = RFID.value;
                            }
                        }
                        product.inputString = inputString;
                        product.amount = row.returnAmount ?? row.amount;
                        product.baseDocumentRow = {
                            amount: row.amount,
                            itemName: row.itemName
                        };
                        product.setNotDiscountable();
                        product.entryMethod = 'Automatic';
                        return product;
                    });
                    return addErrorAlert("Product not found, adding as an unknown item!");
                }else{
                    loadedProducts++;
                    setTimeout(() => {
                        if(allLoaded()){
                            resolve();
                        }
                    }, 1);
                    return addErrorAlert("Product not found");
                }
            }, undefined, undefined, undefined, false, barcode));
        });
    });
};
